import { AxiosInstance } from 'axios';
import { createContext } from 'react';
import {
  AttachmentsApi,
  EntityNamesApi,
  EntityTitlesApi,
  FlattenedIssueTypesApi,
  GovmapGroupsApi,
  IssueActionCountApi,
  IssuesApi,
  IssueSlasApi,
  IssueSubtypesApi,
  IssueTemplatesApi,
  IssueTypesApi,
  MonitoringApi,
  SlasApi,
  UsersApi,
} from '../generated/api';

export interface ApiContextType {
  axios: AxiosInstance;
  issuesApi: IssuesApi;
  issueTypesApi: IssueTypesApi;
  issueSubtypesApi: IssueSubtypesApi;
  flattenedIssueTypesApi: FlattenedIssueTypesApi;
  usersApi: UsersApi;
  issueTemplatesApi: IssueTemplatesApi;
  issueSLAsApi: IssueSlasApi;
  issueEntityNamesApi: EntityNamesApi;
  issueActionCountApi: IssueActionCountApi;
  slasApi: SlasApi;
  govmapGroupsApi: GovmapGroupsApi;
  attachmentsApi: AttachmentsApi;
  monitoringApi: MonitoringApi;
  entityTitlesApi: EntityTitlesApi;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ApiContext = createContext<ApiContextType>({} as any);
